import { render } from "./ChristmasOfferPaywall.vue?vue&type=template&id=8d33701e&scoped=true"
import script from "./ChristmasOfferPaywall.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferPaywall.vue?vue&type=script&lang=js"

import "./ChristmasOfferPaywall.vue?vue&type=style&index=0&id=8d33701e&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d33701e"],['__file',"src/views/paywall/ChristmasOfferPaywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d33701e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d33701e', __exports__)) {
    console.log('reload')
    api.reload('8d33701e', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferPaywall.vue?vue&type=template&id=8d33701e&scoped=true", () => {
    console.log('re-render')
    api.rerender('8d33701e', render)
  })

}


export default __exports__